import React, { memo, useRef, useEffect, useState } from "react";

import { connect } from "react-redux";
import styled from "styled-components";

import { mergeAccounts, getDropdownAccounts } from "actions/dropdown_accounts";
import Modal from "components/Modal";

import { Alert } from "services/Alert";
import { SelectPicker, Schema } from "rsuite";
import Form from "components/Form/CompatForm";

const { StringType } = Schema.Types;
const reverseService = {
    "voice": "sms",
    "sms": "voice"
};


const MergeAccountsModal = memo(({ show, loading, accountId, dropdownAccounts, accountService, setLoading, mergeAccounts, updateCurrentPage, getDropdownAccounts, onClose }) => {
    const formRef = useRef(null);
    const formModel = Schema.Model({
        account_id: StringType()
            .isRequired("This field is required")
    });

    const neededService = reverseService[accountService];
    const [hasError, onHasError] = useState({ error: false, message: null });

    useEffect(() => {
        if (show) {
            getDropdownAccounts({
                service: neededService,
                joined: false
            });
        }
    }, [show]);

    const onSubmit = (data) => {
        setLoading(true);

        const firstAccountId = accountId;
        const secondAccountId = data.account_id;

        mergeAccounts(firstAccountId, secondAccountId).then((response) => {
            if (response && response.account) {
                Alert.success("Accounts was merged!");
                // getList(filters, 1, perPage);
                updateCurrentPage();
                setLoading(false);
            }
        })
    };

    return (
        <Modal
            show={show}
            onClose={() => {
                onClose();
            }}
            footer
            title="Merge accounts"
            extraDisabled={loading}
            successText="Merge"
            onSuccess={() => {
                formRef.current.check();
                const formData = formRef.current.getFormValue();
                const check = formModel.check(formData);
                const error = Object.keys(check).map(key => check[key])[0];
                const errorBody = { error: error.hasError, message: error.errorMessage };
                onHasError(errorBody);

                if (!errorBody.error) {
                    onSubmit(formData);
                    onClose();
                }
            }}
        >
            Account merging means that this account will be connected with selected (under that name). Both accounts will save all traffic, trunks, allocated numbers, currency, payment terms and account manager.
            Dialer will be available see balances, traffic, trunks, allocated numbers, invoices and payments of both accounts in one place and make payment requests for both balances.
            <br />
            <StyledForm
                ref={formRef}
                model={formModel}
            >
                <Form.Group>
                    Select account:
                    <Form.Control
                        name="account_id"
                        valueKey="id"
                        labelKey="name"
                        accepter={SelectPicker}
                        data={dropdownAccounts}
                        errorMessage={hasError.error ? hasError.message : null}
                    />
                </Form.Group>
            </StyledForm>
        </Modal>
    );
});

const mapStateToProps = ({ dropdown_accounts }) => ({
    dropdownAccounts: dropdown_accounts.items
});

const mapDispatchToProps = {
    mergeAccounts,
    getDropdownAccounts
};

export default connect(mapStateToProps, mapDispatchToProps)(MergeAccountsModal);

const StyledForm = styled(Form)`
  margin-top: 20px;
  & .rs-btn {
    margin-right: 10px;
  }
  & .rs-form-control-wrapper {
    width: auto;
    margin-left: 10px
  }
  & .rs-form-control-wrapper .rs-input {
    width: 200px;
  }
`;
